import { Cancellation, PaymentStatus, PositionNumber, PositionNumberType, castConstantType } from 'api/common/constants'
import { positionSelectAPI, positionsAPI } from 'api/position'
import Footer from 'components/Footer'
import Header from 'components/Header'
import MenuItems, { ListItemProps } from 'components/MenuItems'
import { PositionListCard, PositionProps, PositionState } from 'components/PositionListCard'
import * as React from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import loginData from 'utilities/loginData'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [positions, setPositions] = React.useState<PositionProps[]>([])
  const [showToast, setShowToast] = React.useState(false)
  const [isSpinningSubmit, setIsSpinningSubmit] = React.useState(false)
  const [menuItems, setMenuItems] = React.useState<ListItemProps[]>([])

  /**
   * ポジション契約へ
   * @param position ポジション情報
   */
  const onContractConnector = async (position: PositionProps) => {
    setIsSpinningSubmit(true)
    await positionSelectAPI({ positionCount: 1, positionNumber: position.positionNumber }, (result) => {
      if (result) {
        loginData.setPositionContractSelectedData({
          additionPositionCount: 1,
          selectedPositionNumber: position.positionNumber!,
        })
        navigate('/positionContract', { state: { fromPositionManagement: true } })
      }
    })
    setIsSpinningSubmit(false)
  }

  React.useEffect(() => {
    positionsAPI((result) => {
      // 修正: maxPositionCountを固定で使用（重複position_numberの影響を受けない）
      const positionCount = result.maxPositionCount
      const positionProps: PositionProps[] = []
      for (let i = 0; i < positionCount; i++) {
        const positionNumber = castConstantType<PositionNumberType>(i + 1, PositionNumber)
        // 修正: 名義変更されていないポジション（新規登録）を優先して検索
        const position =
          result.positions.find((p) => p.positionNumber === positionNumber && !p.isChangedAssignment) || result.positions.find((p) => p.positionNumber === positionNumber)
        const name = positionNumber === PositionNumber.MainPosition ? 'メインポジション' : `サブポジション${i}`
        if (position) {
          // 購入可能判定: 入金済み+契約中のみが「契約済み」、それ以外は全て購入可能
          // 名義変更済みの場合も元のユーザーから見ると枠が空いている（購入可能）
          // ただし isCampaign=true (キャンペーン発行済) は Unpaid のままでも「契約済み」扱い:
          //   CampaignRegistered ユーザー定常状態の 3 Position を Contracted 表示に流す。
          //   (本登録への昇格は別フロー / 別画面で実施されるため、この画面の
          //    「コネクター登録」ボタンは出さない)
          const isPurchasable =
            position.isChangedAssignment ||
            (!position.isCampaign && !(position.paymentStatus === PaymentStatus.Paid && position.cancellationType === Cancellation.Contract))

          // 復活対象: 未入金+解約 → コネクターID表示、ATEMクエストIDは未設定
          // 完全新規: 入金済み+解約/CO、名義変更 → コネクターID・ATEMクエストID両方非表示
          const isRevivalTarget = position.paymentStatus === PaymentStatus.Unpaid && position.cancellationType === Cancellation.Unsubscribe
          const isNewPurchase = isPurchasable && !isRevivalTarget

          positionProps.push({
            name,
            state: isPurchasable ? PositionState.UnContract : PositionState.Contracted,
            connectorId: isNewPurchase ? '' : position.positionId.toString(),
            atemQuestId: isPurchasable ? '' : position.atemQuestId, // 購入可能な場合は常に未設定表示
            connectorIntroductionLeftURL: position.inviteLeftUrl,
            connectorIntroductionRightURL: position.inviteRightUrl,
            campaignConnectorIntroductionLeftURL: position.campaignInviteLeftUrl,
            campaignConnectorIntroductionRightURL: position.campaignInviteRightUrl,
            userIntroductionURL: `${process.env.REACT_APP_ATEM_QUEST_INVITE_URL}${position.atemQuestId}`,
            positionNumber: castConstantType<PositionNumberType>(i + 1, PositionNumber),
          })
        } else {
          positionProps.push({
            name,
            state: PositionState.UnContract,
            connectorId: '',
            connectorIntroductionLeftURL: '',
            connectorIntroductionRightURL: '',
            campaignConnectorIntroductionLeftURL: '',
            campaignConnectorIntroductionRightURL: '',
            atemQuestId: '',
            userIntroductionURL: '',
            positionNumber: castConstantType<PositionNumberType>(i + 1, PositionNumber),
          })
        }
        setPositions(positionProps)
      }
      const tmpMenuItems: ListItemProps[] = []
      tmpMenuItems.push({
        label: 'コネクター登録',
        path: '/positionSelect',
      })
      tmpMenuItems.push({
        label: '組織管理',
        path: '/organizationManagement',
      })
      setMenuItems(tmpMenuItems)
    })
  }, [])

  return (
    <>
      <Header title="コネクター登録・ポジション管理" />
      <main>
        <section>
          <MenuItems items={menuItems} className="mt-5" />
        </section>
        <section className="mx-4 my-5">
          <h3 className="mt-5 fw-bold">ポジション一覧</h3>
          {positions.map((position, index) => (
            <PositionListCard
              key={index}
              {...position}
              onToast={() => setShowToast(true)}
              onContractConnector={() => onContractConnector(position)}
              isSpinningSubmit={isSpinningSubmit}
            />
          ))}
        </section>
      </main>
      <ToastContainer className="p-3 position-fixed" position="bottom-center" style={{ zIndex: 1 }}>
        <Toast bg="dark" onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
          <Toast.Body className="text-white">コピーしました</Toast.Body>
        </Toast>
      </ToastContainer>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
